import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment";
import mail from "../../assets/images/icon/mail.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import {
  GetQuestionsList,
  DeleteQuestionRecord,
} from "../../services/QuestionsService";
import { toast } from "react-toastify";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { Trans, useTranslation } from "react-i18next";

const QuestionBehaviourList = () => {
  const { t } = useTranslation();
  const [questionList, setQuestionList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const [error, setError] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const companyId = localStorage.getItem("subdomainId");
  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

  useEffect(() => {
    getQuestionList();
    document.title = "NeuroTal - Question List";
  }, []);

  const getQuestionList = async => {
    console.log(lang_id, "lang_id");
    GetQuestionsList(lang_id)
      .then(res => {
        if (res?.data?.status) {
          setQuestionList(res?.data?.data);
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  };

  const handleDeleteRecords = id => {
    DeleteQuestionRecord(id)
      .then(res => {
        if (res?.status === 200) {
          let messages = toast.success(res?.data?.message);
          // window.location.href = '/question-list';
          getQuestionList();
        } else {
          let messages = toast.success(res?.data?.message);
          console.error("Delete record failed:", res?.data?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`mcq_manager.Showing rows`)}
      {from} {t(`mcq_manager.to`)} {to} {t(`mcq_manager.of`)} {size}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = questionList?.filter(renderCheck);
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "question",
      text: t(`mcq_manager.Question`),
      classes: "white-hidden questiontr",
      headerClasses: "white-hidden questiontr",
      formatter: cellContent => <ReadMore content={cellContent} />,
    },
    // {
    //   dataField: "Company.company_name",
    //   text: "Company Name",
    //   hidden: companyId,    // Hide the column if companyId exist
    // },
    {
      dataField: "VacancyType.title",
      text: t(`mcq_manager.Vacancy Type`),
      classes: "white-hidden-img",
    },
    {
      dataField: "competency_category.name",
      text: t(`mcq_manager.Competency Category`),
      classes: "white-hidden",
      formatter: (compCat, row) => {
        let cellContent = row?.competencies?.name || "";

        if (row?.competencies?.length) {
          cellContent = row?.competencies
            ?.map(cat => cat?.name || "")
            ?.filter(cat => !!cat)
            ?.join(", ");
        }

        return <ReadMore content={cellContent} />;
      },
    },
    {
      dataField: "question_type.ques_type",
      text: t(`mcq_manager.Question Type`),
    },
    // {
    //   dataField: "question_parent.ques_parent",
    //   text: "Question Parent",
    //   classes:"white-hidden"
    // },
    // {
    //   dataField: "ques_behav_id",
    //   text: "Question Behaviour",
    // },
    // {
    //   dataField: "text_preced_item",
    //     text: "Text Preceding Item",
    // },
    // {
    //   dataField: "enabler",
    //     text: "Enabler",
    // },
    // {
    //   dataField: "scenario",
    //     text: "Scenario",
    //     formatter:(cellContent,row) => (
    //       <>{row?.scenario == '1' ? 'Work' : 'Non Work'}</>
    //     ),
    // },

    // {
    //   dataField: "option1",
    //   text: "Option 1",
    // },
    // {
    //   dataField: "option2",
    //   text: "Option 2",
    // },
    // {
    //   dataField: "option3",
    //   text: "Option 3",
    // },
    // {
    //   dataField: "option4",
    //   text: "Option 4",
    // },
    // {
    //   dataField: "weightage1",
    //   text: "Weightage 1",
    // },
    // {
    //   dataField: "weightage2",
    //   text: "Weightage 2",
    // },
    // {
    //   dataField: "weightage3",
    //   text: "Weightage 3",
    // },
    // {
    //   dataField: "weightage4",
    //   text: "Weightage 4",
    // },

    // {
    //   dataField: "image_file",
    //   text: "Image",
    //   classes:"white-hidden-img"
    // },
    // {
    //   dataField: "audio_file",
    //   text: "Audio",
    // },

    {
      dataField: "createdAt",
      text: t(`mcq_manager.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`mcq_manager.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`mcq_manager.Active`)
            : t(`mcq_manager.In Active`)}
        </>
      ),
    },
  ];

  if (checkPermissionStatus("questions-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`mcq_manager.Actions`),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-question/${row.id}`}
                title="Edit Question"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>Edit</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleDeleteRecords(row.id)}
                className="text-success blue-icon blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title="Delete Record"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>Delete</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = item => {
    const searchableText = (
      item?.question +
      item?.vacancy_type_id +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1" ? "Active" : "In Active")
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  
  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const ReadMore = ({ content }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleReadMore = () => setIsExpanded(!isExpanded);

    const maxLength = 100; // Adjust to your preferred character limit

    // If content is short, display it fully without the "Read More" button
    if (content.length <= maxLength) {
      return (
        <>
          <p className="content-para">{content}</p>
        </>
      );
    }
    if (!checkPermissionStatus("questions-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

    return (
      <div>
        {isExpanded ? content : `${content.substring(0, maxLength)}...`}
        <button onClick={toggleReadMore} className="readmoreless">
          {isExpanded ? " Read Less " : " Read More "}
        </button>
      </div>
    );
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />

                    {t(`mcq_manager.Questions List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive white-space-row pb-3">
                <div className="table-data-search moile-ar">
                  <div className="total-record">
                    <h5>
                      {t(`mcq_manager.Total Records`)}:{" "}
                      <span>{questionList?.length || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <div className="serach-bar-top">
                      <form class="form-inline">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder={t(`mcq_manager.Search by question name`)}
                          aria-label="Search"
                          onChange={e => setQuery(e.target.value)}
                          title={t(`mcq_manager.Search by question name`)}
                        />
                        <span>
                          <img src={serach_icon} alt="search" />
                        </span>
                      </form>
                    </div>

                    {checkPermissionStatus("questions-list", "downloadcsv") && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "id",
                              label: "S No.",
                            },
                            {
                              key: "question",
                              label: "Question",
                            },
                            {
                              key: "VacancyType.title",
                              label: "Position Level",
                            },

                            {
                              key: "competency_category.name",
                              label: "Competency Category",
                            },
                            {
                              key: "question_type.ques_type",
                              label: "Question Type",
                            },
                            {
                              key: "ques_behav_id",
                              label: "Question Behaviour",
                            },
                            {
                              key: "question_parent.ques_parent",
                              label: "Question Parent",
                            },
                            {
                              key: "text_preced_item",
                              label: "Text Preceding Item",
                            },
                            {
                              key: "enabler",
                              label: "Enabler",
                            },
                            {
                              key: "scenario",
                              label: "Scenario",
                              transform: value =>
                                value === 1 ? "Work" : "Non Work",
                            },

                            {
                              key: "option1",
                              label: "Option 1",
                            },
                            {
                              key: "option2",
                              label: "Option 2",
                            },
                            {
                              key: "option3",
                              label: "Option 3",
                            },
                            {
                              key: "option4",
                              label: "Option 4",
                            },
                            {
                              key: "weightage1",
                              label: "Weightage 1",
                            },
                            {
                              key: "weightage2",
                              label: "Weightage 2",
                            },
                            {
                              key: "weightage3",
                              label: "Weightage 3",
                            },
                            {
                              key: "weightage4",
                              label: "Weightage 4",
                            },
                            {
                              key: "answer",
                              label: "Answer",
                            },
                            // {
                            //   key: "image_file",
                            //   label: "Image",
                            // },
                            // {
                            //   key: "audio_file",
                            //   label: "Audio",
                            // },

                            {
                              key: "status",
                              label: "Status",
                              transform: value =>
                                value === 1 ? "Active" : "Inactive",
                            },
                            {
                              key: "createdAt",
                              label: "Created Date",
                            },
                            // {
                            //   key: !companyId ? "Company.company_name" : "", // Conditionally include "Company Name" if companyId does't exists
                            //   label: !companyId ? "Company Name" : "",
                            // },
                          ]}
                          filename={`QuestionsList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />
                            {t(`mcq_manager.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    {checkPermissionStatus("questions-list", "create") && (
                      <div className="take-text filter">
                        <Link to="/create-question" className="btn btn-primary">
                          + {t(`mcq_manager.Create`)}
                        </Link>
                      </div>
                    )}

                    <div className="tale-text right-panel">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>
                {successMessage && (
                  <div class="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div class="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}

                {/* <div className="timeto-hire-card userlist questionparent"> */}
                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      <div className="table-pending-list">
                        {questionList?.length > 0 && (
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={questionList?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                            />
                          </div>
                        )}

                        {questionList?.length === 0 && (
                          <>
                            <div className="no-data data-available">
                              <img
                                src="../img/data-not-available.png"
                                alt="data not availble"
                              />
                              <h3> {t(`mcq_manager.No Item Found`)}</h3>
                              <p>
                                {t(`mcq_manager.Sorry, we could not find any`)}
                                <br /> {t(`mcq_manager.Item to show here`)}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionBehaviourList;
